// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3VNqP","OrderButton":"BuildControls_OrderButton__2ERZg","enable":"BuildControls_enable__3tPok"};